// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".name[data-v-49b15996]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:4rem}@media (min-width:24.375em){.name[data-v-49b15996]{max-width:6rem}}@media (min-width:28em){.name[data-v-49b15996]{max-width:8rem}}@media (min-width:40em){.name[data-v-49b15996]{max-width:12rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
